
// src/store/thunks/companySeoThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import companySeoService from "../../services/companySeoService";

export const fetchCompanySeoThunk = createAsyncThunk(
  "companySeo/fetchCompanySeo",
  async (_, { rejectWithValue }) => {
    try {
      const seo = await companySeoService.getCompanySeo();
      return seo;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateCompanySeoThunk = createAsyncThunk(
  "companySeo/updateCompanySeo",
  async (seoData, { rejectWithValue }) => {
    try {
      const updatedSeo = await companySeoService.updateCompanySeo(seoData);
      return updatedSeo;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);